import Vue from 'vue'
import Router from 'vue-router'
import VueResource from 'vue-resource'
import myhome from '@/components/myhome/myhome'
import storyCsrs from '@/components/story/csrs' //创始人说
import storyYpjs from '@/components/story/ypjs' //燕铺介绍
import starGyxl from '@/components/mystar/gyxl' //干燕系列
//import starXxxl from '@/components/mystar/xxxl' //享鲜系列
import starMmxl from '@/components/mystar/mmxl' //面膜系列
import starYjxl from '@/components/mystar/yjxl' //鱼胶系列
import starEjxl from '@/components/mystar/ejxl' //享鲜系列
import starJydbxl from '@/components/mystar/jydbxl' //胶原蛋白系列
import praise from '@/components/praise/praise' //顾客口碑
import forumYpbb from '@/components/forum/ypbb' //燕铺辨别
import forumYpsp from '@/components/forum/ypsp' //燕铺食谱
import vipHyjj from '@/components/vip/hyjj' //会员见证
import vipHyfl from '@/components/vip/hyfl' //会员福利
import check from '@/components/check/check' //会员福利
Vue.use(Router)
Vue.use(VueResource)
export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'myhome',
            component: myhome
        },
        {
            path: '/storyCsrs',
            name: 'storyCsrs',
            component: storyCsrs
        },
        {
            path: '/storyYpjs',
            name: 'storyYpjs',
            component: storyYpjs
        },
        {
            path: '/starGyxl',
            name: 'starGyxl',
            component: starGyxl
        },

        {
            path: '/starYjxl',
            name: 'starYjxl',
            component: starYjxl
        },
        {
            path: '/starMmxl',
            name: 'starMmxl',
            component: starMmxl
        },
        {
            path: '/starEjxl',
            name: 'starEjxl',
            component: starEjxl
        },
        {
            path: '/starJydbxl',
            name: 'starJydbxl',
            component: starJydbxl
        },
        {
            path: '/praise',
            name: 'praise',
            component: praise
        },
        {
            path: '/forumYpbb',
            name: 'forumYpbb',
            component: forumYpbb
        },
        {
            path: '/forumYpsp',
            name: 'forumYpsp',
            component: forumYpsp
        },
        {
            path: '/vipHyjj',
            name: 'vipHyjj',
            component: vipHyjj
        },
        {
            path: '/vipHyfl',
            name: 'vipHyfl',
            component: vipHyfl
        },
        {
            path: '/check',
            name: 'check',
            component: check
        },

    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js